import React from "react";

export default function ExchangeWarning() {
  return (
    <div className="row m-r-10">
      <div className="col-sm-12">
        <div className="alert alert-warning">
          <div className="media">
            <div className="media-left">
              <i className="fa fa-lg fa-warning text-warning" />
            </div>
            <div className="media-body">
              Heads Up - Don&apos;t forget to select &apos;Exchange Gone{" "}
              Outright&apos; button, if applicable, to notify the exchange
              manager to create the outright sales order.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ActionRequested/ExchangeWarning.jsx